import imageDe from '../images/de/uploader-abbottXtra-3.png';
import imageEn from '../images/en/uploader-abbottXtra-3.png';
import imageEs from '../images/es/uploader-abbottXtra-3.png';
import imageFi from '../images/fi/uploader-abbottXtra-3.png';
import imageFr from '../images/fr/uploader-abbottXtra-3.png';
import imageIt from '../images/it/uploader-abbottXtra-3.png';
import imageNo from '../images/no/uploader-abbottXtra-3.png';
import imageSv from '../images/sv/uploader-abbottXtra-3.png';

export const uploaderUploadingImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
